module.exports = {"520325100":"玉溪镇","520325101":"三江镇","520325102":"隆兴镇","520325103":"旧城镇","520325104":"忠信镇","520325105":"洛龙镇","520325106":"阳溪镇","520325107":"三桥镇","520325108":"大磏镇","520325109":"平模镇","520325200":"上坝土家族乡","520325201":"棕坪乡","520325202":"桃源乡","520325203":"河口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520325.json
// module id = 2282
// module chunks = 0